import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators, AbstractControl, ValidatorFn } from '@angular/forms';
import { Http } from '@angular/http';
import { SettingsService } from '../settings/settings.service';
import { Observable } from 'rxjs/Observable';

const requiredMessage = 'This field is required';
const passwordMatchMessage = 'Passwords do not match';
const invalidEmailMessage = 'Not a valid email';
const invalidPassword = 'Password is not valid';


@Injectable()
export class CustomValidatorsService {

    private errorMessage: string[];

    constructor(private http: Http,
        private _settingsService: SettingsService


    ) { }

    required(control: FormControl) {
        let regex = new RegExp('(^$)');
        return !regex.test(control.value) ? null : { 'required': true };
    }










    validatePasswordsMatch(group: FormGroup) {



        return group.get("password").value == group.get("confirmPassword").value ? null : { 'passwordMatch': true };
        //   return { 'invalidPassword': true };
        //this.hitchdForm.get('password').value,
        //       if  ()
        //       {
        // let test= group.get("confirmPassword");
        //       }
        //r
    }

   max(max: number): ValidatorFn {
return (control: FormControl): { [key: string]: boolean } | null => {

  let val: number = control.value;

  if (control.pristine || control.pristine) {
    return null;
  }
  if (val <= max) {
    return null;
  }
  return { 'max': true };
  }
}

 min(min: number): ValidatorFn {
return (control: FormControl): { [key: string]: boolean } | null => {

  let val: number = control.value;

  if (control.pristine || control.pristine) {
    return null;
  }
  if (val >= min) {
    return null;
  }
  return { 'min': true };
  }
}

    passwordIsValid(group: FormGroup) {
        return group.controls['password'].valid ? null : { 'invalidPassword': true };
    }


    containsUpperCase(control: FormControl) {
        let regex = new RegExp('(?=.*?[A-Z])');
        return regex.test(control.value) ? null : { 'containsUpperCase': true };
    }

    containsLowerCase(control: FormControl) {

        let regex = new RegExp('(?=.*?[a-z])');
        return regex.test(control.value) ? null : { 'containsLowerCase': true };
    }

    containsSpecial(control: FormControl) {
        let regex = new RegExp(/\W|_/g);
        return regex.test(control.value) ? null : { 'containsSpecial': true };
    }


    validateEmail(control: FormControl) {
        let EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (control.value != "" && (control.value.length <= 5 || !EMAIL_REGEXP.test(control.value))) {
            return { "Please provide a valid email": true };
        }

        return null;
    }

    emailWithTLD(control: FormControl) {
        // This regex requires at least one dot after @ and a TLD of 2+ characters
        // It supports multiple TLD levels like .co.uk, .co.jp
        let EMAIL_WITH_TLD_REGEXP = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

        if (!control.value) {
            return null; // Let required validator handle empty values
        }

        if (!EMAIL_WITH_TLD_REGEXP.test(control.value)) {
            return { "email": true };
        }

        return null;
    }




    buildErrorMessages(control: FormControl, formGroup: FormGroup) {

        this.errorMessage = [];
        this.buildControlErrorMessages(control);
        if (formGroup != null) {
            this.buildFormErrorMessages(formGroup);
        }
        return this.errorMessage;
    }

    buildControlErrorMessages(control: FormControl) {

        if (control.hasError('required')) {
            this.errorMessage.push(requiredMessage);
        }

        if (control.hasError('passwordMatch')) {
            this.errorMessage.push(passwordMatchMessage);
        }

        if (control.hasError('validateEmail')) {
            this.errorMessage.push(invalidEmailMessage);
        }
    }

    buildFormErrorMessages(formGroup: FormGroup) {
        if (formGroup.hasError('passwordMatch')) {
            this.errorMessage.push(passwordMatchMessage);
        }

        if (formGroup.hasError('invalidPassword')) {
            this.errorMessage.push(invalidPassword);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/validators.service.ts